import { DropDown } from "../../commons";
import "react-datepicker/dist/react-datepicker.css";
import ReportsDateSelect from "../../commons/ReportsDateSelect/ReportsDateSelect";
import { components } from "react-select";
import { BranchListType } from "../../../screens/Reports/ProfitLoss";
import LedgerStatementFilter from "./LedgerStatementFilter";
import { LedgerStatementType } from "../../../redux/reports/reportsType";

type FilterMultiSelectDataType = {
  invoiceType: { label: string; value: number | null };
  transactionAmountType: { label: string; value: string | null };
  transactionAmountLimitType?:
    | { label: string; value: string | null }
    | undefined;
  value: string;
};
type OptionsType = {
  value: any;
  label: any;
};

type AppProps = {
  allLedgersList: OptionsType[];
  ledgerName: OptionsType;
  handleSetLedger: (ledgerName: any) => void;
  startDate: any;
  endDate: any;
  handleStartDateChange: (date: any) => void;
  handleEndDateChange: (date: any) => void;
  handleSubmitData: () => void;
  client_code: number | string;
  ledgerListFetching: boolean;
  toggle: boolean;
  setToggle: (data: boolean) => void;
  handlePrepareDownload: () => void;
  branchList: BranchListType[] | [];
  handleBranchChange: (data: BranchListType) => void;
  branchSelected: BranchListType;
  filterToggle: boolean;
  setFilterToggle: React.Dispatch<React.SetStateAction<boolean>>;
  filterValue: any;
  setFilterValue: any;
  handleApplyFilter: () => void;
  handleFilterClear: () => void;
  multiSelectData: FilterMultiSelectDataType;
  ledgerStatement: [] | LedgerStatementType[];
};

const LedgerStatementHeader = ({
  allLedgersList,
  ledgerName,
  handleSetLedger,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  handlePrepareDownload,
  ledgerListFetching,
  toggle,
  setToggle,
  branchList,
  branchSelected,
  handleBranchChange,
  filterToggle,
  setFilterToggle,
  filterValue,
  setFilterValue,
  handleFilterClear,
  handleApplyFilter,
  multiSelectData,
  ledgerStatement,
}: AppProps) => {
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  return (
    <div className="d-flex position-relative justify-content-start align-items-center">
      <div className="col-md-3 form-group">
        <label>Ledger Name</label>
        <div>
          <DropDown
            options={allLedgersList}
            value={ledgerName}
            handleChange={handleSetLedger}
            components={{ Option }}
          />
        </div>
      </div>
      <div className="form-group ml-2 mr-4" style={{ width: "15%" }}>
        <label>Branch</label>
        <DropDown
          options={
            branchList
              ? [{ value: "", label: "Select Branch..." }, ...branchList]
              : [{ value: "", label: "Select Branch..." }]
          }
          value={branchSelected}
          handleChange={handleBranchChange}
        />
      </div>
      <div className="form-group">
        <label>Date</label>
        <div>
          <ReportsDateSelect
            type={"ledgerStatement"}
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
        </div>
      </div>

      <div className="col-md-3 mt-2">
        <button
          className="btn btn-primary"
          onClick={handleSubmitData}
          disabled={
            !ledgerName.value || !startDate || !endDate || ledgerListFetching
          }
        >
          Get Statement
        </button>
      </div>
      {/* Commented for future use */}
      <div className="right-header mt-2" style={{ marginLeft: "101px" }}>
        <div className="mr-1">
          <LedgerStatementFilter
            setToggle={setFilterToggle}
            toggle={filterToggle}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            handleApplyFilter={handleApplyFilter}
            handleFilterClear={handleFilterClear}
            multiSelectData={multiSelectData}
            ledgerStatement={ledgerStatement}
          />
        </div>
      </div>
    </div>
  );
};

export default LedgerStatementHeader;
